export default function notFalsy<TValue>(value: TValue | null | undefined | false | ""): value is TValue {
  return value !== null && value !== undefined && value !== false && value !== "";
}
